import { JSONSchema6 } from "json-schema";

const getRefundSchema: JSONSchema6 = {
    title: "Get Refund",
    description: "Get refund details.",
    properties: {
        "pathParam": {
            title: "refundId",
            type: "string",
        }
    },
    required: ["pathParam"]
}

export default getRefundSchema